import * as types from '../actions/actionTypes';

let initialState = {
    references: {
        loading: false,
        success: true,
        data: []
    },
    keyword: '',
    createReference: {
        loading: false,
        success: false,
        data: {}
    },
    updateReference: {
        loading: false,
        success: false,
        data: {}
    }
};

export default function referencesReducer(state = initialState, action) {
    switch (action.type) {
        case types.START_GET_REFERENCES:
            return Object.assign({}, state, { references: { ...initialState.references, loading: true } });
        case types.GET_REFERENCES:
            return Object.assign({}, state, { references: action.response });

        case types.UPDATE_REFERENCES_SEARCH:
            return Object.assign({}, state, { keyword: action.keyword });

        case types.START_CREATE_REFERENCE:
            return Object.assign({}, state, { createReference: { ...initialState.createReference, loading: true } });
        case types.CREATE_REFERENCE:
            return Object.assign({}, state, { createReference: action.response });

        case types.START_UPDATE_REFERENCE:
            return Object.assign({}, state, { updateReference: { ...initialState.updateReference, loading: true } });
        case types.UPDATE_REFERENCE:
            return Object.assign({}, state, { updateReference: action.response });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ReferencesReducer.js